export const convertNumberToMoney = (money?: number) => {
  if (money === 0) {
    return 0;
  } else if (!money) {
    return;
  }
  return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
